import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/nouzei_01.png")